import * as pageApi from 'Api/page';
import {
  SET_LOADING,
  SET_PAGE_DATA,
} from './mutation-types';

export default {
  async getPageData({ commit, getters }, { slug }) {
    if (slug === getters.pageData.slug) return Promise.resolve();
    commit(SET_LOADING, true);
    try {
      const { data } = await pageApi.getPageData(slug);
      commit(SET_PAGE_DATA, data);
      commit(SET_LOADING, false);
      return data;
    } catch (error) {
      commit(SET_LOADING, false);
      throw error;
    }
  },
};
